import {
  AccountPaymentMethod,
  AddPaymentMethodFormSubmitEvent,
  PadAgreementFormSubmitEvent,
  PaymentAccount,
  PaymentDateValidationResult,
  SelectPaymentMethodFormSubmitEventOnBackNavigation,
  SelectPaymentMethodFormSubmitEventOnForwardNavigation,
} from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const HostedPaymentsSelectPaymentMethodActions = createActionGroup({
  source: 'Hosted Payments Select Payment Method Component',
  events: {
    'Payment Account Selected': props<{
      payload: PaymentAccount;
    }>(),
    'Proceed To Review': props<{
      selectPaymentMethod: SelectPaymentMethodFormSubmitEventOnForwardNavigation;
    }>(),
    'Back To Payment Details': props<{
      selectPaymentMethod: SelectPaymentMethodFormSubmitEventOnBackNavigation;
    }>(),
    'Add Payment Method Form Submitted': props<{
      paymentMethod: AddPaymentMethodFormSubmitEvent;
    }>(),
    'Payment Method Type Selected': props<{
      paymentMethodType: AccountPaymentMethod;
      cardOverrideUsed?: boolean;
    }>(),
    'Payment Date Validated': props<{
      paymentDateValidationResult: PaymentDateValidationResult;
    }>(),
    'Close Add Payment Method Dialog': props<{
      payload: {
        hasPaymentAccounts: boolean;
      };
    }>(),
    'Submitted Add Pad Agreement Form': props<{
      payload: PadAgreementFormSubmitEvent;
    }>(),
    'Canceled Add Pad Agreement Form': emptyProps(),
    'Initialize Select Payment Method Step': emptyProps(),
    'Open Add Payment Method Dialog': emptyProps(),
    'Show Card Restriction Toast': emptyProps(),
    'Selected Bank Account Missing Pad': emptyProps(),
    'Submitted Add Pad Form For Selected Bank Account': props<{
      payload: PadAgreementFormSubmitEvent;
    }>(),
    'Signed Pad Separately For Selected Bank Account': emptyProps(),
    'Twikey Signature Failed': props<{
      payload: { paymentMethodDisplayName: string };
    }>(),
  },
});
